<template>
  <div id="app">
    <Header v-if="isHeaderVisible" />
    <main id="main">
      <router-view />
    </main>
    <div class="footer-container">
      <Footer v-if="isFooterVisible" />
    </div>
  </div>
</template>

<script setup>
import { onMounted, computed } from "vue";
import { useRoute } from "vue-router";
import Footer from "@/components/Footer/Footer.vue";
import Header from "@/components/Header.vue";
import { ROUTES } from "@/const";

onMounted(() => {
  const reditusScript = document.createElement("script");
  const reditusScriptContent = document.createTextNode(
    '(function(w, d, s, p, t) { w.gr = w.gr || function() { w.gr.q = w.gr.q || []; w.gr.q.push(arguments); }; p = d.getElementsByTagName(s)[0]; t = d.createElement(s); t.async = true; t.src = "https://app.getreditus.com/gr.js?_ce=60"; p.parentNode.insertBefore(t, p); })(window, document, "script"); gr("track", "pageview");',
  );
  reditusScript.appendChild(reditusScriptContent);
  document.head.appendChild(reditusScript);
});

const route = useRoute();

const isHeaderVisible = computed(
  () => !route.fullPath.startsWith(ROUTES.get("EXTERNAL_AUTH").path),
);
const isFooterVisible = computed(
  () => !route.fullPath.startsWith(ROUTES.get("EXTERNAL_AUTH").path),
);
</script>
